<div class="header">
  Edit your records
</div>
<div class="card">
  <div class="card-body">
    <div class="accordion dark-accordion" ngbAccordion [closeOthers]="false" [destroyOnHide]="false">
      @for(item of accordionData; track item) {
        <div class="accordion-item" ngbAccordionItem #accItem="ngbAccordionItem">
          <h2 ngbAccordionHeader class="accordion-header">
            <button class="accordion-button" type="button" ngbAccordionButton (click)="itemCall(item)">
             <!-- <app-svg-icon [icon]="item.icon"></app-svg-icon> -->
              {{ item.title }}
            </button>
          </h2>
          <div class="accordion-collapse" ngbAccordionCollapse>
            <div class="accordion-body" ngbAccordionBody>

              <!-- JSON-driven form -->
              <app-form-setup
                [FromJson]="activeForms[item.id] || []"
                [id]="item.id"
                [submitForm]="formTriggers[item.id] || false"
                (formEmitted)="submitformCheck($event)"
                (formCheck)="formSubmit($event, item.id)">
              </app-form-setup>

              <!-- JSON-driven detail cards (only once, below form) -->
              <div class="row mt-3" *ngIf="item.detail?.tab as tabs">
                <div class="col-6" *ngFor="let tab of tabs">
                  <div class="detail_container">
                    <div class="header">{{ tab.header }}</div>
                    <div class="body" *ngFor="let field of tab.item">
                      <span class="label">{{ field.label }}</span>
                      <span class="value">{{ field.value }}</span>
                    </div>
                  </div>
                </div>
              </div>


            </div>
            <div class="bottom w-100 d-flex">
              <button class="btn" style="color: #00587D;" type="button" (click)="accItem.collapse()">Close</button>
              <button class="btn btn-primary" (click)="triggerForm(item.id)">Update</button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
